declare var global: any;
declare var process: any;

if (global.AUTOBAHN_DEBUG === undefined)
  global.AUTOBAHN_DEBUG = (process && process.env.AUTOBAHN_DEBUG) || false;

import { Connection, Session, IInvocation, IRegistration, IPublishOptions, IPublication, SubscribeHandler, ISubscription, ISubscribeOptions, RegisterEndpoint, IRegisterOptions, ICallOptions, Error, auth_cra } from 'autobahn';
// import modelStream from 'api/ModelStream';
import when from 'when';
// import EventBus from 'minivents';

export class Wamp {
  connection: Connection;
  session: Session;
  url: any;
  realm: any;
  closeDeferred: When.Deferred<void>;
  sessionDeferred: When.Deferred<Session>;
  auth: any;

  // sessionPromise: this.sessionDeferred.promise,

  // constructor(url: string, realm: string) {
  constructor() {
    this.closeDeferred = when.defer();
    this.sessionDeferred = when.defer();
  }

  onOpen = (s: Session) => {
    this.session = s;
    console.log(`[WAMP] session to ${this.url} (realm: ${this.realm}) established!`);
    this.sessionDeferred.resolve(this.session);
  }


  onClose = (reason: string, details: any): boolean => {
    console.log(`[WAMP] session to ${this.url} (realm: ${this.realm}) closed! Reason: (${reason}, ${details.reason})`);

    let stop_retrying = false;

    // Not getting expected results with nexus router
    if (reason === 'closed')
      return stop_retrying;


    // Patch broken wamp.rt implementation
    if (details.reason === 'wamp.error.goodbye_and_out')
      details.reason = 'wamp.close.normal';

    if (details.reason !== 'wamp.close.normal') {
      console.warn(`[WAMP] session unexpectedly closed! Reason: ${reason}, details: ${JSON.stringify(details)}`);
    }

    // this.events.emit('CLOSE', this.session, reason, details);
    this.session = null;
    this.closeDeferred.resolve();
    return stop_retrying;
  };

  onchallenge = (session, method, extra) => {

    if (method === "wampcra") {
      console.log("authenticating via '" + method + "' and challenge '" + extra.challenge + "'");
      return auth_cra.sign(this.auth.key, extra.challenge);
    } else {
      throw "don't know how to authenticate using '" + method + "'";
    }
  }

  connect(url: string, realm: string, authString?: string): When.Promise<Session> {
    console.log(`[WAMP] init with ${url} (realm: ${realm}, auth: ${JSON.stringify(authString)})`);
    // this.on('REGISTER', ::this.onRegister);

    let auth;

    if (authString) {
      const s = authString.split(':');
      auth = {
        user: s[0],
        key: s[1]
      };
    }


    this.closeDeferred = when.defer();
    this.sessionDeferred = when.defer<Session>();
    this.url = url;
    this.realm = realm;
    this.auth = auth;

    const connectionConfig: any = {
      url: url,
      realm: realm,
      retry_if_unreachable: true,
      max_retries: -1,
      initial_retry_delay: 1.0,
      max_retry_delay: 10,
      retry_delay_growth: 1.2,
      authmethods: auth ? ["wampcra"] : undefined,
      authid: auth ? auth.user : undefined,
      onchallenge: this.onchallenge,

      // NOTE: Not available in current npm release
      on_user_error: (error, customErrorMessage) => {
        console.log(`on_user_error: `, error);
      },
      on_internal_error: (error, customErrorMessage) => {
        console.log(`on_internal_error: `, error);
      }
    };

    this.connection = new Connection(connectionConfig);

    this.connection.onopen = this.onOpen;
    this.connection.onclose = this.onClose;


    this.connection.open();
    return this.sessionDeferred.promise;
  }

  publish(topic: string, args?: any[], kwargs?: any, options?: IPublishOptions): When.Promise<IPublication> {
    return this.session.publish(topic, args, kwargs, options);
  }

  subscribe(topic: string, handler: SubscribeHandler, options?: ISubscribeOptions): When.Promise<ISubscription> {
    return this.session.subscribe(topic, handler, options);
  }

  // register(procedure: string, endpoint: RegisterEndpoint, options?: IRegisterOptions): When.Promise<IRegistration>;

  register(uri: string, callback): When.Promise<IRegistration> {

    const onCall = async (args?: any[], kwargs?: any, details?: IInvocation) => {
      try {
        console.log(`[RPC] call ${uri}`);
        return await callback(args, kwargs);
      }
      catch (e) {
        console.warn(`Exception in RPC callback ${uri}.`, e);
        throw new Error(uri, [e.toString(), e.stack]);
      }
    };

    const options: any = {
      invoke: 'last'
    };

    return this.session.register(uri, onCall, options);
  }


  unsubscribe(subscription: ISubscription): When.Promise<any> {
    return this.session.unsubscribe(subscription);
  }

  unregister(registration: IRegistration): When.Promise<any> {
    return this.session.unregister(registration);
  }

  call<TResult>(procedure: string, args?: any[], kwargs?: any, options?: ICallOptions): When.Promise<TResult> {
    try {
      let result: any = this.session.call(procedure, args, kwargs, options);

      result.catch(e => {
        console.log(`[WAMP] Caught exception`, e);
      });

      return result;
    }
    catch (e) {
      // console.log(`[WAMP] error`, e);
      throw e;
    }
  }


  close() {
    this.connection.close();
    return this.closeDeferred.promise;
  }

}


let wamp = new Wamp();
export default wamp;



// WEBPACK FOOTER //
// ../appserver/js-jobserver/lib/wamp.ts